import PropTypes from 'prop-types'

import { Icon } from '@blocket/blocket-ui'

const forwardArrow = Icon.svguri`
<svg width="32" height="32" xmlns="http://www.w3.org/2000/svg">
  <g fill="none" fill-rule="evenodd">
    <path d="M16 0C11.494.03 6.989 1.151 4.1 4.1 1.15 6.99.03 11.494 0 16c.03 4.506 1.151 9.011 4.1 11.9C6.989 30.85 11.494 31.97 16 32c4.506-.03 9.01-1.151 11.9-4.1 2.949-2.889 4.07-7.395 4.1-11.9-.03-4.506-1.151-9.011-4.1-11.9C25.011 1.15 20.505.03 16 0z" fill-opacity=".5" fill="#000"/>
    <path d="M13.828 22.981a.946.946 0 0 0 .683-.295l5.468-5.642c.194-.2.303-.475.302-.764 0-.289-.109-.564-.303-.763l-5.468-5.63a.938.938 0 0 0-1.392.032 1.115 1.115 0 0 0 .03 1.497l4.727 4.866-4.729 4.878a1.114 1.114 0 0 0-.028 1.496.945.945 0 0 0 .71.325" fill="#FFF"/>
  </g>
</svg>
`

const backwardArrow = Icon.svguri`
<svg width="32" height="32" xmlns="http://www.w3.org/2000/svg">
  <g fill="none" fill-rule="evenodd">
    <path d="M16 0C11.494.03 6.989 1.151 4.1 4.1 1.15 6.99.03 11.494 0 16c.03 4.506 1.151 9.011 4.1 11.9C6.989 30.85 11.494 31.97 16 32c4.506-.03 9.01-1.151 11.9-4.1 2.949-2.889 4.07-7.395 4.1-11.9-.03-4.506-1.151-9.011-4.1-11.9C25.011 1.15 20.505.03 16 0z" fill-opacity=".5" fill="#000"/>
    <path d="M17.172 22.981a.946.946 0 0 1-.683-.295l-5.468-5.642a1.09 1.09 0 0 1-.302-.764c0-.289.109-.564.303-.763l5.468-5.63a.938.938 0 0 1 1.392.032 1.115 1.115 0 0 1-.03 1.497l-4.727 4.866 4.729 4.878c.392.404.404 1.076.028 1.496a.945.945 0 0 1-.71.325" fill="#FFF"/>
  </g>
</svg>
`

const ArrowIcon = ({ width = 32, height = 32, previous = true, ...props }) => (
  <Icon
    width={width}
    height={height}
    icon={previous ? backwardArrow() : forwardArrow()}
    {...props}
  />
)

ArrowIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  previous: PropTypes.bool,
}

export default ArrowIcon
